import React from 'react';

import { warningColor } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import View from '@zego/components/atoms/View';

interface FormFieldWarningProps {
  warning: string;
  isErrorsPositionStatic?: boolean;
}

const FormFieldWarning = ({
  warning,
  isErrorsPositionStatic,
}: FormFieldWarningProps): JSX.Element => {
  return (
    <View
      css={{
        position: isErrorsPositionStatic ? 'static' : 'absolute',
        left: 0,
      }}
    >
      <RegularText
        css={{
          fontSize: 14,
          color: warningColor(5),
        }}
      >
        {warning}
      </RegularText>
    </View>
  );
};

export default FormFieldWarning;
